import { defineStore } from "pinia";
import router from "@/router/index";

export const useRouteStore = defineStore("routeStore", {
  state: () => ({
    hasRoutes: false,
    dynamicRoutes: [],
  }),
  actions: {
    setRoutesState(hasRoutes) {
      this.hasRoutes = hasRoutes;
    },
    addRoute(route) {
      this.dynamicRoutes.push(route);
    },
    clearRoutes() {
      this.dynamicRoutes = [];
    },
    initRoutes(menuList) {
      this.dynamicRoutes = this.menuListToRoutes(menuList);
    },
    hasRoute(name) {
      return this.dynamicRoutes.some((route) => route.name === name);
    },
    menuListToRoutes(menuList) {
      const routes = router.options.routes;
      menuList.forEach((menu) => {
        if (menu.children) {
          menu.children.forEach((m) => {
            let route = this.menuToRoute(m, menu.name);
            const isRouteExist = routes[0].children.some(
              (child) => child.name === route.name
            );
            if (!isRouteExist) {
              routes[0].children.push(route);
            }
          });
        }
      });
      return routes;
    },
    menuToRoute(menu, parentName) {
      if (!menu.component) {
        return null;
      } else {
        let route = {
          name: menu.name,
          path: menu.path,
          meta: {
            parentName: parentName,
          },
        };
        route.component = () => import("../views/" + menu.component + ".vue");
        return route;
      }
    },
    resetRoutes() {
      this.dynamicRoutes.forEach((route) => {
        router.removeRoute(route.name);
      });
      this.dynamicRoutes = [];
      this.hasRoutes = false;
    },
  },
});
